<template lang="pug">
  app-modal(
    :titulo="titulo",
    :width="width"
    @closeModal="$emit('closeModal')"
  )
    template(slot="body")
      el-row(type='flex')
        el-col(:span="12").container-input
          app-label(label="Número do Ofício", :required="true")
          el-input.input.w-70(
            v-model="oficio.numeroOficio"
            :disabled="true"
          )
        el-col(:span="12").container-input
          app-label(label="Município", :required="true")
          el-input.input.w-70(
            v-model="oficio.cartorio.municipio.nome"
            :disabled="true"
          )
      el-row(type="flex").margin-bottom
        el-col(:span="12").container-input
          app-label(label="Nome do Cartório", :required="true")
          el-input.input.w-70(
            v-model="oficio.cartorio.nome"
            :disabled="true"
          )
        el-col(:span="12").container-input
          app-label(label="Data de Emissão do Ofício", :required="true")
          el-input.input.w-70(
            v-model="dataEmissao"
            :disabled="true"
          )
      app-pdf-editor(
        :conteudo="conteudo"
        @onTextChange="onTextChange"
        @getRawDocument="getRawDocument"
      )
    template(slot="footer")
      div.flex
        el-button(@click="salvarEdicao")
          i.fal.fa-file-pdf
          span &nbsp Salvar Edição
</template>

<script>
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import AppPdfEditor from '@/screens/arrecadacao/components/AppPDFEditor'
import FileHelper from '@/utils/fileHelper'
import { mapActions } from 'vuex'
import utils from '../../../../utils/utils'

export default {
  components: {
    AppModal,
    AppPdfEditor,
    FileHelper,
    AppLabel
  },

  props: {
    titulo: { required: true, type: String },
    width: { default: 1024, type: Number },
    documentoId: { required: true, type: Number },
    oficio: { required: true, type: Object }
  },

  data () {
    return {
      conteudo: '',
      novoConteudo: ''
    }
  },

  methods: {
    ...mapActions({
      editarOficio: 'oficioArrecadacao/editarOficio',
      findRawDocument: 'oficioArrecadacao/getRawDocument'
    }),

    onTextChange (val) {
      this.novoConteudo = val
    },

    async salvarEdicao () {
      const bytes = await this.editarOficio({
        conteudo: this.novoConteudo,
        documentoId: this.documentoId
      })
      this.$emit('onUpdatePDF', bytes)
    },

    async getRawDocument () {
      this.conteudo = await this.findRawDocument(this.documentoId)
    }
  },

  computed: {
    dataEmissao () {
      return utils.formatDate(this.oficio.dataEmissao)
    }
  }

}
</script>

<style scoped lang="scss">
p.message {
  width: 80%;
  margin: 0 auto;
}

.flex {
  display: flex;
  justify-content: flex-end;
}

.w-70 {
  width: 70%;
}

.margin-bottom {
  margin-bottom: 5%;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/cpat/components/ModalEditarOficio.vue